import { render, staticRenderFns } from "./dialog-secondary.vue?vue&type=template&id=6de376c6&scoped=true&"
import script from "./dialog-secondary.vue?vue&type=script&lang=js&"
export * from "./dialog-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de376c6",
  null
  
)

export default component.exports